import React, { useState, useEffect, useRef } from 'react';

function BlogPosts() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    // Hashnode's GraphQL API is now Pro-gated and its RSS feed isn't reachable
    // from the browser (CORS), so posts come from our own /blog Lambda, which
    // proxies the RSS feed server-side and returns clean JSON.
    fetch('https://api.joel-fernandes.com/blog', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data?.posts)) {
          setPosts(data.posts);
        } else {
          setError(true);
        }
        setLoading(false);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!sectionRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('blog-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const cards = sectionRef.current.querySelectorAll('.blog-card');
    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, [posts]);

  if (error || (!loading && posts.length === 0)) {
    return null;
  }

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const truncate = (text, maxLength = 120) => {
    if (!text || text.length <= maxLength) return text;
    return text.substring(0, maxLength).trimEnd() + '...';
  };

  return (
    <section className='blog-section' ref={sectionRef}>
      <h2 className='blog-heading'>Latest Blog Posts</h2>
      <div className='blog-grid'>
        {loading
          ? Array.from({ length: 6 }).map((_, i) => (
              <div className='blog-card blog-skeleton' key={i}>
                <div className='blog-card-image skeleton-image' />
                <div className='blog-card-body'>
                  <div className='skeleton-title' />
                  <div className='skeleton-text' />
                  <div className='skeleton-text short' />
                  <div className='skeleton-date' />
                </div>
              </div>
            ))
          : posts.map((post, i) => (
              <a
                href={post.url}
                target='_blank'
                rel='noopener noreferrer'
                className='blog-card'
                key={post.url || i}
                style={{ animationDelay: `${i * 0.1}s` }}
              >
                {post.coverImage && (
                  <div className='blog-card-image'>
                    <img src={post.coverImage} alt={post.title} />
                  </div>
                )}
                <div className='blog-card-body'>
                  <h3 className='blog-card-title'>{post.title}</h3>
                  <p className='blog-card-brief'>{truncate(post.brief)}</p>
                  <span className='blog-card-date'>{formatDate(post.date)}</span>
                </div>
              </a>
            ))}
      </div>
    </section>
  );
}

export default BlogPosts;
